/*
 * Сканер-клавиатура в украинской раскладке присылает кириллицу вместо
 * латиницы: `Ф-2-05` вместо `A-2-05` (INV-07, СК-04). Код переводится по
 * клавишам ЙЦУКЕН → QWERTY. Сервер делает то же; экран переводит сам там,
 * где сверяет код без сервера (строки открытой заявки).
 */
const LAYOUT: Record<string, string> = {
  Й: "Q", Ц: "W", У: "E", К: "R", Е: "T", Н: "Y", Г: "U", Ш: "I", Щ: "O", З: "P",
  Ф: "A", І: "S", Ы: "S", В: "D", А: "F", П: "G", Р: "H", О: "J", Л: "K", Д: "L",
  Я: "Z", Ч: "X", С: "C", М: "V", И: "B", Т: "N", Ь: "M",
};

export function latinizeCode(code: string): string {
  return code.trim().toUpperCase().replace(/./gu, (ch) => LAYOUT[ch] ?? ch);
}
